// extracted by mini-css-extract-plugin
module.exports = {"block":"content_block__1P9aB","tabItem":"content_tabItem__3aE1C"};